import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { Outlet, RouteObject } from "react-router-dom";
import { Page } from "../order/page";

export const retailRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <Page alwaysShowNavbar>
          <Outlet />
        </Page>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        lazy: async () => {
          const { RetailActions } = await import(
            "@redotech/redo-customer-portal-app/register/retail-actions"
          );
          return { element: <RetailActions /> };
        },
      },
      {
        path: "register",
        lazy: async () => {
          const { Main: RegistrationPortal } = await import(
            "@redotech/redo-customer-portal-app/register/main"
          );
          return { element: <RegistrationPortal /> };
        },
      },
      {
        path: "claim",
        lazy: async () => {
          const { Main: RegistrationPortal } = await import(
            "@redotech/redo-customer-portal-app/register/main"
          );
          // TODO: Is claim only
          return { element: <RegistrationPortal /> };
        },
      },
      {
        path: "registrations",
        children: [
          {
            path: ":id",
            lazy: async () => {
              const { RegisteredWarrantyDetails } = await import(
                "../warranties/registered-warranty-details"
              );
              return { element: <RegisteredWarrantyDetails /> };
            },
          },
        ],
      },
    ],
  },
];
